import { render, staticRenderFns } from "./LiquidityPool.vue?vue&type=template&id=2351d8d2&scoped=true&"
import script from "./LiquidityPool.vue?vue&type=script&lang=js&"
export * from "./LiquidityPool.vue?vue&type=script&lang=js&"
import style0 from "./LiquidityPool.vue?vue&type=style&index=0&id=2351d8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351d8d2",
  null
  
)

export default component.exports